import React, { useCallback, useEffect, useState } from 'react';
import { getEventIntent } from '../../../data/api';
import EventReadinessHome from './EventReadinessHome';
import './orchestration.css';

/**
 * Event Readiness — entry point.
 *
 * The orchestration home is the single surface. The ~3-question intake
 * (PlanIntake, launched from the home) replaces the former six-screen Vision
 * Consultation, and the tab is non-blocking: the home renders immediately and
 * the intake is an in-place action, not a gate.
 */
export default function EventReadinessPage({ onNavigateToModule, focusEntity }) {
  const [intent, setIntent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadIntent = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      setIntent(await getEventIntent());
    } catch (err) {
      setError(err?.response?.data?.detail || 'Unable to load Event Readiness.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadIntent(); }, [loadIntent]);

  if (loading) {
    return (
      <section className="ero">
        <div className="ero-wrap">
          <div className="ero-statemsg" aria-busy="true" style={{ marginTop: 48 }}>Loading Event Readiness…</div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="ero">
        <div className="ero-wrap">
          <div className="ero-statemsg err" role="alert" style={{ marginTop: 48 }}>
            {error}{' '}
            <button type="button" className="ero-twhy" onClick={loadIntent}>Try again</button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <EventReadinessHome
      intent={intent}
      onNavigateToModule={onNavigateToModule}
      focusEntity={focusEntity}
    />
  );
}
